import React from 'react';
import { cn } from '@/lib/utils';
import { Label } from '../ui/label';
import { PROFILE_INTENTION, PROFILE_INTENTION_OPTIONS } from '../../utils/profileIntention';

/**
 * Optional profile intention — UI-only until persisted server-side.
 */
export function ProfileIntentionPicker({
  value = PROFILE_INTENTION.STANDARD,
  onChange,
  compact = false,
  className,
  'data-testid': testId = 'profile-intention-picker',
}) {
  return (
    <div className={cn('space-y-2', className)} data-testid={testId}>
      <Label className={compact ? 'text-xs text-muted-foreground' : undefined}>
        Profile intention <span className="font-normal text-muted-foreground">(optional)</span>
      </Label>
      {!compact ? (
        <p className="text-xs leading-relaxed text-muted-foreground">
          Helps tailor gentle prompts. Still a standard person profile in your archive.
        </p>
      ) : null}
      <div className={cn('grid gap-2', compact ? 'grid-cols-1' : 'sm:grid-cols-3')}>
        {PROFILE_INTENTION_OPTIONS.map((opt) => {
          const selected = value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange?.(opt.value)}
              className={cn(
                'rounded-xl border px-3 py-2.5 text-left transition',
                selected
                  ? 'border-[#c9a961]/45 bg-[#c9a961]/8 ring-1 ring-[#c9a961]/20'
                  : 'border-[hsl(38_14%_86%)] bg-[hsl(42_28%_99%)] hover:border-[hsl(38_14%_78%)]'
              )}
              data-testid={`profile-intention-${opt.value}`}
            >
              <p className="text-sm font-medium text-foreground/90">{opt.label}</p>
              {!compact ? (
                <p className="mt-1 text-[11px] leading-relaxed text-muted-foreground">{opt.description}</p>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ProfileIntentionPicker;
